import script from "./FeedbackList.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackList.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackList.vue?vue&type=style&index=0&id=54c22346&lang=scss"

const __exports__ = script;

export default __exports__